import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { Icon } from '@iconify/react';
import useResponsive from '../../../../../../Hooks/useResponsive';

const WillCard = ({ data, handleDeletePopup, induvidualView }) => {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');
  const { libraryName, libraryDescription, created_on } = data;
  return (
    <Box>
      <Paper
        sx={{
          border: 0.4,
          borderColor: 'grey.300',
          mb: 2,
          borderRadius: 3,
          transition: 'box-shadow 0.3s ease',
          '&:hover': {
            boxShadow: 3,
            '.rotating-icon': {
              animation: 'spin 3s linear infinite',
            },
          },
          '@keyframes spin': {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' },
          },
        }}
      >
        <Stack direction={smUp ? 'row' : 'column'} spacing={2}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.6,
              p: 1,
              width: '100%',
            }}
          >
            <Box
              className="rotating-icon"
              sx={{
                backgroundColor: '#2f72b342',
                color: '#2f72b3',
                height: 40,
                width: 40,
                borderRadius: '50%',
                p: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Icon icon="hugeicons:atomic-power" width="24" height="24" />
            </Box>
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {libraryName}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              width: '100%',
            }}
          >
            <Box
              sx={{
                pt: 0.5,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {' '}
              <Chip
                size="small"
                sx={{ fontSize: 8, height: 16 }}
                label={'Description'}
                variant="outlined"
                color="primary"
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                // variant="subtitle2"
                sx={{ color: 'grey.500', textAlign: 'left', fontSize: 12 }}
              >
                {libraryDescription}
              </Typography>
            </Box>
          </Box>
          {!induvidualView && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                width: '100%',
                pr: 2,
                pb: smUp ? '' : 2,
              }}
            >
              <Button
                startIcon={<Icon icon="weui:delete-outlined" width="18" height="18" />}
                color="error"
                size="small"
                sx={{ borderRadius: 4 }}
                onClick={() => handleDeletePopup(data)}
                variant="outlined"
              >
                Delete
              </Button>
            </Box>
          )}
        </Stack>
      </Paper>
    </Box>
  );
};

export default WillCard;
